export default "__VITE_ASSET__CiDIE4TE__"